import { useEffect, useRef } from "react";

import { hoverLegendItemAtom } from "atoms/interaction";
import { IS_BOX_PLOT_CHART, IS_CROSS_PLOT_CHART } from "constants/chart.constants";
import { EvaChart } from "constants/charts.enums";
import { useChartsContext } from "contexts/ChartContext";
import { useAtomValue } from "jotai";

import { useChartEntities } from "hooks/charts";

import { ContextMenu, CopyUWIButton } from "../toggles";

function CopyUwiContextMenu() {
  const { id } = useChartsContext();
  const { chartType, sum, jitterPlotToggle, contextMenu } = useChartEntities(id);
  const hoverLegendItem = useAtomValue(hoverLegendItemAtom);
  const uwiRef = useRef<Maybe<string>>(null);

  const isSpaghetti = sum?.active;
  const isJitterActive = jitterPlotToggle?.active;
  const isScatterWithUwi =
    (IS_BOX_PLOT_CHART(chartType) && isJitterActive) ||
    IS_CROSS_PLOT_CHART(chartType) ||
    chartType === EvaChart.Probit;

  const copyUWIContextMenuAllowed = isSpaghetti || isScatterWithUwi;
  const contextMenuVisible = Boolean(contextMenu?.point);

  // Track the last non-empty hover item so the context menu still has a UWI
  // after the pointer leaves (right-click arrives after mouse-out).
  useEffect(() => {
    if (!hoverLegendItem) return;
    uwiRef.current = hoverLegendItem;
  }, [hoverLegendItem]);

  return (
    <ContextMenu
      allow={copyUWIContextMenuAllowed}
      visible={contextMenuVisible}
      position={contextMenu?.point}
      content={<CopyUWIButton uwi={uwiRef.current} id={id} />}
    />
  );
}

export default CopyUwiContextMenu;
